import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContextApi } from "../../../store/ContextApi";
import PageTitle from "../../layouts/PageTitle";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import FaildLoadData from "../../global-components/FaildLoadData/FaildLoadData";
import { Link, useParams } from "react-router-dom";
import { getSingleRoleFunc } from "../../../store/custom-actions/roles-actions/GetSingleRoleSlicer";
import EmptyData from "../../components/empty-data/EmptyData";
import { useTranslation } from "react-i18next";

export default function SingleRolePage() {
  const { t } = useTranslation();
  const contextApi = useContext(ContextApi);
  const [rolePermissionsList, setRolePermissionsList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { roleId } = useParams();
  const singleRole_api = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/roles/${roleId}`;
  const { loading: getSingleRoleLoading, data: singleRoleData } = useSelector(
    (state) => state.getSingleRoleSlicer
  );
  useEffect(() => {
    const getSingleRole = async () => {
      dispatch(getSingleRoleFunc(singleRole_api));
    };
    getSingleRole();
  }, []);
  useEffect(() => {
    singleRoleData && setRolePermissionsList(singleRoleData.permissions);
  }, [singleRoleData]);

  useEffect(() => {
    singleRoleData &&
      singleRoleData.permissions &&
      setRolePermissionsList(singleRoleData.permissions);
    singleRoleData &&
      singleRoleData.permissions &&
      (jobData.current = singleRoleData.permissions.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      ));
  }, [singleRoleData]);
  const sort = 20;
  let paggination = Array(Math.ceil(rolePermissionsList.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const activePag = useRef(0);
  const jobData = useRef(
    rolePermissionsList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    )
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = rolePermissionsList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };
  const search = () => {
    if (searchValue !== "") {
      const searchResult =
        singleRoleData.permissions &&
        singleRoleData.permissions.length >= 1 &&
        singleRoleData.permissions.filter((permission) =>
          permission.name
            .toLocaleLowerCase()
            .includes(searchValue.toLocaleLowerCase())
        );
      jobData.current = searchResult;
    } else {
      dispatch(getSingleRoleFunc(singleRole_api));
    }
  };
  useEffect(() => {
    searchValue == "" && dispatch(getSingleRoleFunc(singleRole_api));
  }, [searchValue]);
  return (
    <>
      <PageTitle motherMenu={"Roles"} activeMenu={"Role Permissions"} />
      {getSingleRoleLoading ? (
        <SpinnerLoading />
      ) : singleRoleData ? (
        rolePermissionsList && rolePermissionsList.length >= 1 ? (
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">{t("Permissions")}</h4>
                <div className="add-and-search d-flex align-items-center">
                  <div className="input-group search-area">
                    <span className="input-group-text" onClick={() => search()}>
                      <Link to="#">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M27.414 24.586L22.337 19.509C23.386 17.928 24 16.035 24 14C24 8.486 19.514 4 14 4C8.486 4 4 8.486 4 14C4 19.514 8.486 24 14 24C16.035 24 17.928 23.386 19.509 22.337L24.586 27.414C25.366 28.195 26.634 28.195 27.414 27.414C28.195 26.633 28.195 25.367 27.414 24.586ZM7 14C7 10.14 10.14 7 14 7C17.86 7 21 10.14 21 14C21 17.86 17.86 21 14 21C10.14 21 7 17.86 7 14Z"
                            fill="var(--primary)"
                          />
                        </svg>
                      </Link>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Search here...")}
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>#{t("ID")}</th>
                        <th>{t("Name")}</th>
                        <th>{t("Guard Name")}</th>
                        <th>{t("Creation Date")}</th>
                        <th>{t("Last Update")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobData.current.map((role, index) => (
                        <tr key={index}>
                          <td>{role.id}</td>
                          <td>{role.name}</td>
                          <td>{role.guard_name}</td>
                          <td>
                            {new Date(role.created_at).toLocaleDateString()}
                          </td>
                          <td>
                            {new Date(role.updated_at).toLocaleDateString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="d-sm-flex justify-content-between align-items-center mt-3">
                    <div className="dataTables_info">
                      {t("Showing")} {activePag.current * sort + 1} to{" "}
                      {rolePermissionsList.length >
                      (activePag.current + 1) * sort
                        ? (activePag.current + 1) * sort
                        : rolePermissionsList.length}{" "}
                      {t("Of")} {rolePermissionsList.length} {t("Entries")}
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers">
                      <Link
                        className="paginate_button previous"
                        to="#"
                        onClick={() =>
                          activePag.current > 0 &&
                          onClick(activePag.current - 1)
                        }
                      >
                        <i className="fa fa-angle-double-left" />
                      </Link>
                      <span>
                        {paggination.map((number, i) => (
                          <Link
                            key={i}
                            to="#"
                            className={`paginate_button ${
                              activePag.current === i ? "current" : ""
                            }`}
                            onClick={() => onClick(i)}
                          >
                            {number}
                          </Link>
                        ))}
                      </span>
                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={() =>
                          activePag.current + 1 < paggination.length &&
                          onClick(activePag.current + 1)
                        }
                      >
                        <i className="fa fa-angle-double-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <EmptyData emptyText={"This Role Not Have Any Permissons !"} />
        )
      ) : (
        <FaildLoadData
          refetchDataFunc={() => dispatch(getSingleRoleFunc(singleRole_api))}
        />
      )}
    </>
  );
}
